import React, { useState } from 'react';

import './PrizesAndWeight.css';

import WeightChart from './WeightChart/WeightChart';
import PrizesChart from './PrizesChart/PrizesChart';

const brackets = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '[6-10[',
  '[10-15[',
  '[15-20[',
  '[20-25[',
  '[25-30[',
  '[30-35[',
  '[35-40[',
  '[40-45[',
  '[45-50[',
  '[50-55[',
  '[55-60[',
  '> 60'
];

const years = [
  '2020',
  '2019',
  '2018',
  '2017'
];

function PrizesAndWeight(props) {

  const [rangesSelected, setRangesSelected] = useState({
    '1': true,
    '2': true,
    '3': true,
    '4': true,
    '5': true,
    '[6-10[': true,
    '[10-15[': true,
    '[15-20[': true,
    '[20-25[': true,
    '[25-30[': true,
    '[30-35[': true,
    '[35-40[': true,
    '[40-45[': true,
    '[45-50[': true,
    '[50-55[': true,
    '[55-60[': true,
    '> 60': true
  });

  const updateRangeFilter = (event) => {
    const clickedValue = event.target.value;
    // console.log('unselect this', clickedValue);
    setRangesSelected({
      ...rangesSelected, 
      [clickedValue]: !rangesSelected[clickedValue]
    });
    
    // console.log('unselect this', rangesSelected[clickedValue]);
    props.rangeFilterChange(clickedValue);
  }

  const [yearsSelected, setYearsSelected] = useState({
    '2017': true,
    '2018': true,
    '2019': true,
    '2020': true
  });

  const updateYearFilter = (event) => {
    const clickedValue = event.target.value;
    // console.log(clickedValue);
    setYearsSelected({
      ...yearsSelected, 
      [clickedValue]: !yearsSelected[clickedValue]
    });
    props.yearFilterChange(clickedValue);
  }

  return (
    <> 
    <div class="prizesContainer">
      <div class="dropdown">
        <div class="allBracketsButtonContainer">
          <button class="allBracket">All bracket</button>
          <button class="plusButton">+</button>
        </div>
        <div class="dropdown-content">
          {brackets.map(bracket => {
            return <button 
                  className={rangesSelected[bracket] ? 'color': ''}     
                  value={bracket} onClick={updateRangeFilter}>{bracket}</button>
          })}
        </div>
      </div>

      <div class="bracketDropdown">
          {/* Selected brackets */}
          <div>
          {brackets.map(bracket => {
            return rangesSelected[bracket] && 
            <div>
              {bracket}
            </div>
          })}
          </div>
      </div>
    </div>

    <div class="prizesAndWeightChart">
        <div class="yearsContainer">
            <div class="yearsSelected">

                {yearsSelected['2020'] && <div id="year2020">
                  2020  
                </div>}
                
                {yearsSelected['2019'] && <div id="year2019">
                  2019
                </div>}
                  
                {yearsSelected['2018'] && <div id="year2018">
                  2018 
                </div>}

               {yearsSelected['2017'] && <div id="year2017">
                  2017  
                </div>}

            </div>
            <div class="yearDropdown">
              <div class="allYearsButtonContainer">
                <button class="allYears">All years</button>
                <button class="yearPlusButton">+</button>
              </div>
            <div class="yearDropdownContent">
            {years.map(year => {
              return <button 
                    className={yearsSelected[year] ? 'color': ''}     
                    value={year} onClick={updateYearFilter}>{year}</button>
              })
            }
            </div>
          </div>
        </div>
      <div class="prizesChartDiv">
        <PrizesChart 
          prizesChartData={props.prizesChartData} 
          />
      </div>
      <div class="weightChartDiv">
        <WeightChart
          weightChartData={props.weightChartData}
        />
      </div>
    </div>
    </>
  )
}

export default PrizesAndWeight;
